module.exports = "/static/assets/922310d46a823ad4a24968f5a8ab1fdc.png";